import { render, staticRenderFns } from "./CampaignProspector.vue?vue&type=template&id=20300b61"
import script from "./CampaignProspector.vue?vue&type=script&lang=js"
export * from "./CampaignProspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports